import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["CustomPR"] */ "/app/src/blocks/press-release/variants/custom-pr.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/src/components/button.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["ComparisonSlider"] */ "/app/src/components/comparison-slider/index.jsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/link.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["InternalVideo"] */ "/app/src/components/media/elements/internal-video.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["Video"] */ "/app/src/components/media/elements/video.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageLayout"] */ "/app/src/features/site/ui/layouts/page-layout.jsx");
